<template>
  <v-container class="text-center pr-0 pl-0" fluid>

    <v-card class="mb-5" :disabled="$store.getters.dialogLoaderMain" id="topoLista">
      <v-card-title class="primary">Filtros {{ (items ? '(total de ' + items.length + ' treinos)' : '')
        }}</v-card-title>
      <v-card-text class="mb-5 pt-10 pb-0">

        <v-row>

          <v-col cols="12" md="4" sm="12">
            <v-select dense prepend-icon="mdi-account" :items="alunoList" v-model="alunoSelecionado"
              label="Aluno (deixe vazio para buscar todos)" item-text="fullName" clearable return-object></v-select>
          </v-col>

          <v-col cols="12" md="4" sm="12">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense v-model="formattedDateInicio" label="Data de início" prepend-icon="mdi-calendar"
                  readonly v-bind="attrs" v-on="on" @change="changeData"></v-text-field>
              </template>
              <v-date-picker v-model="dateInicio" @input="menu1 = false;"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="4" sm="12">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense :error-messages="showErrorDates ? ['A data final deve ser posterior'] : []"
                  v-model="formattedDateFim" label="Data fim" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                  v-on="on" @change="changeData"></v-text-field>
              </template>
              <v-date-picker v-model="dateFim" @input="menu2 = false;"></v-date-picker>
            </v-menu>
          </v-col>

        </v-row>
      </v-card-text>

      <v-card-actions class="">
        <v-spacer></v-spacer>
        <v-btn width="100%" class="primary" text @click="aplicarFiltros" :disabled="showErrorDates">
          Aplicar Filtros
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- <card-treino v-bind:item="item" v-for="item in items" :key="item.id" :showAluno="showAluno"/> -->
    <v-row>
      <v-col v-for="item in items" :key="item.id" cols="12" md="4" lg="4">
        <card-treino :item="item" :showAluno="showAluno" />
      </v-col>
    </v-row>


    <transparent-message-box :myMessage="myMessage" v-if="(!items || items.length < 1) && finishedLoad" />

    <v-btn fab dark medium color="primary" fixed right bottom v-if="position[1] > 80" transition="slide-x-transition"
      @click="scrollToTheTop" class="mb-12">
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>

  </v-container>
</template>

<script>
import CardTreino from '../../components/CardTreino.vue';
import TransparentMessageBox from '../../components/TransparentMessageBox.vue';
import {myMixin} from '../../mixin';
import windowScrollPosition from '../../mixin/window-scroll-position'
import moment from 'moment';

//import axios from 'axios';
import HOST from '../../ws'
//import SnackBar from "../snackbar";


export default {

  components : {
    CardTreino,
    TransparentMessageBox,
  },

  mixins : [
    myMixin,
    windowScrollPosition('position'),
  ],

  props: {
    source: String
  },

  beforeMount () {

    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    console.log('de ' + this.formataData(new Date()) + ' a ' + this.formataData(tomorrow));
  },

  mounted (){
    this.formattedDateInicio = moment().format("DD/MM/YYYY"); 
    this.formattedDateFim = moment().add(2, 'days').format("DD/MM/YYYY"); 

    this.reloadItemList();
    this.reloadAlunoList();
  },  

  data: () => ({
    
    items : null,
    showAluno : true,
    finishedLoad : false,

    myMessage : 'Não há treinos dos seus alunos para o dia.',
    showErrorDates : false,

    numeroDeDias : null,
    alunoSelecionado : null,

    alunoList : null,

    //data de inicio:
    dateInicio: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    formattedDateInicio : null,
    menu1: false,
    modal: false,

    //data de inicio:
    dateFim: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    formattedDateFim : null,
    menu2: false,

  }),

  watch : {
    dateInicio(){
      if(this.dateInicio && this.dateInicio != ''){
        this.formattedDateInicio = '';
        this.formattedDateInicio += this.dateInicio.substring(8);
        this.formattedDateInicio += '/';
        this.formattedDateInicio += this.dateInicio.substring(5, 7);
        this.formattedDateInicio += '/';
        this.formattedDateInicio += this.dateInicio.substring(0, 4);

        this.changeData();
      }else{
        this.formattedDateInicio = null;
      }
    },
    dateFim(){
      if(this.dateFim && this.dateFim != ''){
        this.formattedDateFim = '';
        this.formattedDateFim += this.dateFim.substring(8);
        this.formattedDateFim += '/';
        this.formattedDateFim += this.dateFim.substring(5, 7);
        this.formattedDateFim += '/';
        this.formattedDateFim += this.dateFim.substring(0, 4);
        
        this.changeData();
      }else{
        this.formattedDateFim = null;
      }
    }
  },

  methods : {

    scrollToTheTop(){
      //window.scrollTo(0,0);

      const myEl = this.$refs.topoLista || this.$el || document.getElementById('topoLista');
      this.$smoothScroll({
        scrollTo: myEl,
        offset: -100,
      });
    },

    changeData(){
      this.showErrorDates = false;
      if(this.formattedDateInicio && this.formattedDateFim){
        
        let start = moment(this.formattedDateInicio, "DD-MM-YYYY");
        let end = moment(this.formattedDateFim, "DD-MM-YYYY");
        console.log('diferenca das datas: ' + start.diff(end, 'days'))
        if(start.diff(end, 'days') >= 0){
          this.showErrorDates = true;
        }
      }
    },  

    aplicarFiltros(){
      console.log('aplicando filtros');
      //this.reloadItemListFiltered();
      this.reloadItemList();
    },  

    reloadAlunoList(){

      this.$store.commit("setLoader", true);
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(HOST.HOST + '/user/allalunos', {}, config)
      .then(response => {
        this.alunoList = response.data;
        this.$store.commit("setLoader", false);
        //this.finishedLoad = true;
      })
      .catch((error) => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit('logout');
        this.$router.push("login");
      });
    },

    reloadItemList(){

      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      //console.log(moment(moment(this.dateFim).add(1, 'days'), "DD/MM/YYYY") );

      this.$store.commit("setLoader", true);
      let requestData = {
        inicio : this.formattedDateInicio,
        fim : this.formattedDateFim,
        alunoId : (this.alunoSelecionado ? this.alunoSelecionado.id :  null)
      }
      this.axios({
        method: 'post',
        url : HOST.HOST + '/treino/todosostreinosdodia', 
        headers: {
            'Content-Type' : 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`},
            data : JSON.stringify(requestData)
      }).then((response) => {

        console.log('consulta dos treinos: ' + response.status); 
        this.items = response.data;
        this.$store.commit("setLoader", false);
        this.finishedLoad = true;
        
        //console.log(JSON.stringify(this.items));
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },

    reloadItemListFiltered(){

      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      this.$store.commit("setLoader", true);
      let requestData = {
        dataInicioFormatted : this.formattedDateInicio,
        dataFimFormatted : this.formattedDateFim,
      }
      this.axios({
        method: 'post',
        url : HOST.HOST + '/treino/alltreinosporperiodo', 
        headers: {
            'Content-Type' : 'application/json',
            Authorization: `Bearer ${this.$store.state.currentToken}`},
            data : requestData
      }).then((response) => {

        console.log('consulta dos treinos filtrados: ' + response.status); 
        this.items = response.data;
        this.$store.commit("setLoader", false);
        this.finishedLoad = true;
        //console.log(JSON.stringify(this.items));
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
      });
    }
  }
};
</script>

<style>



</style>